import React, { useState, useEffect } from "react";
import MembersDashboard from "./MembersDashboard";

const DashboardContainer = () => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    if (!user) {
        return <p>Loading user information...</p>;
    }

    return <MembersDashboard user={user} />;
};

export default DashboardContainer;
